<div class="container">
    <form [formGroup]="dropdownentry">
        <div class="nav material-icons">
            <button mat-icon-button (click)="onSort(-1)" [disabled]="seq==0">
                <mat-icon>arrow_drop_up</mat-icon>
            </button>
            <button mat-icon-button (click)="onSort(1)" [disabled]="seq==last">
                <mat-icon>arrow_drop_down</mat-icon>
            </button>
        </div>
        <mat-form-field>
            <mat-label>Value</mat-label>
            <input matInput formControlName="value">
        </mat-form-field>
        <mat-form-field>
            <mat-label>Text</mat-label>
            <input matInput formControlName="text">
        </mat-form-field>
        <button mat-button (click)="onDelete()">delete</button>
    </form>
</div>